<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading">
  <p class="text[#627189] mb-4 mr-5 ml-0 pt-0 dark:text-white">Profile</p>

  <div class="w-full px-10 py-4 bg-tileLight dark:bg-[#363638] shadow-lg rounded-lg ">
    <div class="flex flex-col gap-7 px-2 py-2" id="reportcontainer">
      <h1 class="text-[#030308] font-semibold dark:text-white">My profile</h1>
      <div class="flex flex-row justify-between items-center border-[#F1F7FA] border-[3px] rounded-lg p-6">
        <div class="flex flex-row items-center">
          <!-- Profile Image with border and size adjustment -->
          <!-- <img class="w-28 h-28 rounded-full border-4 border-[#F1F7FA]"
                     src="https://images.pexels.com/photos/845457/pexels-photo-845457.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" /> -->
          <div *ngIf="officerObj.image">
            <img class="w-28 h-28 rounded-full object-cover" [src]="officerObj.image" />
          </div>

          <div *ngIf="!officerObj.image"
            class="flex rounded-full border-solid border-2 justify-center items-center w-32 h-32">
            <i class="fa-regular fa-user text-6xl dark:text-white"></i>
          </div>
          <div class="ml-6">
            <!-- Profile Text with proper spacing -->
            <p class="text-lg font-semibold text-[#030308] dark:text-white">
              {{ officerObj.firstNameEnglish }} {{ officerObj.lastNameEnglish }}
            </p>
            <p class="text-[#627189] dark:text-textDark">
              {{
              officerObj.jobRole
              }}
              - <span class="text-[#030308] dark:text-textDark">{{ officerObj.empId }}</span>
            </p>
            <p *ngIf="logingRole === 'Collection Centre Manager'" class="font-semibold text-[#030308] dark:text-white">
              {{ officerObj.regCode }} Centre
            </p>

            <p *ngIf="logingRole === 'Distribution Centre Manager'"
              class="font-semibold text-[#030308] dark:text-white">
              {{ officerObj.distributionRegCode }} Centre
            </p>

            <p class="text-[#627189] dark:text-textDark">{{ officerObj.companyNameEnglish }}</p>
          </div>
        </div>

        <!-- Buttons with consistent size and styling -->
        <div class="flex flex-row space-x-4 self-start mt-2">
          <button (click)="goToChangePassword()"
            class="bg-[#415CFF] text-white font-semibold rounded-lg shadow-md px-4 py-2">
            Change Password
          </button>
          <button *ngIf="logingRole === 'Collection Centre Manager'"
            class="bg-[#415CFF] text-white font-semibold rounded-lg shadow-md px-4 py-2" (click)="navigateToTarget()">
            View My Target
          </button>
        </div>
      </div>

      <div class="border-[#F1F7FA] border-[3px] rounded-lg p-6">
        <div class="flex flex-row justify-between">
          <p class="font-semibold text-[#030308] dark:text-white">Personal Infomation</p>
        </div>

        <div class="grid grid-cols-2 gap-4 text-[#627189] my-4">
          <div>
            <p class="text-[#627189] dark:text-textDark">First Name</p>
            <p class="font-semibold text-[#000000] dark:text-white">
              {{ officerObj.firstNameEnglish }}
            </p>
          </div>

          <div>
            <p class="text-[#627189] dark:text-textDark">Last Name</p>
            <p class="font-semibold text-[#000000] dark:text-white">
              {{ officerObj.lastNameEnglish }}
            </p>
          </div>

          <div>
            <p class="text-[#627189] dark:text-textDark">NIC Number</p>
            <p class="font-semibold text-[#000000] dark:text-white">
              {{ officerObj.nic }}
            </p>
          </div>

          <div>
            <p class="text-[#627189] dark:text-textDark">Email</p>
            <p class="font-semibold text-[#000000] dark:text-white">
              {{ officerObj.email }}
            </p>
          </div>

          <div>
            <p class="text-[#627189] dark:text-textDark">Mobile Number - 1</p>

            <p class="font-semibold dark:text-white text-black">{{ officerObj.phoneNumber01 ?
              officerObj.phoneCode01 + officerObj.phoneNumber01 : ' - ' }}
            </p>

            <!-- <p class="font-semibold text-[#000000] dark:text-white">
              {{ phone1 }}
            </p> -->
          </div>

          <div>
            <p class="text-[#627189] dark:text-textDark">Mobile Number - 2</p>
            <p class="font-semibold dark:text-white text-black">
              {{ officerObj.phoneNumber02 ? officerObj.phoneCode02 + officerObj.phoneNumber02 : ' - ' }}
            </p>
            <!-- <p class="font-semibold text-[#000000] dark:text-white">
              {{ phone2 }}
            </p> -->
          </div>
        </div>
      </div>

      <div class="border-[#F1F7FA] border-[3px] rounded-lg shadowmd p-6">
        <p class="font-semibold text-[#030308] dark:text-white">Address Details</p>

        <div class="grid grid-cols-2 gap-4 text-[#627189] my-4">
          <div>
            <p class="text-[#627189] dark:text-textDark">House / Plot Number</p>
            <p class="font-semibold text-[#000000] dark:text-white">
              {{ officerObj.houseNumber }}
            </p>
          </div>

          <div>
            <p class="text-[#627189] dark:text-textDark">Street Name</p>
            <p class="font-semibold text-[#000000] dark:text-white">
              {{ officerObj.streetName }}
            </p>
          </div>

          <div>
            <p class="text-[#627189] dark:text-textDark">City</p>
            <p class="font-semibold text-[#000000] dark:text-white">
              {{ officerObj.city }}
            </p>
          </div>

          <div>
            <p class="text-[#627189] dark:text-textDark">Country</p>
            <p class="font-semibold text-[#000000] dark:text-white">
              {{ officerObj.country }}
            </p>
          </div>

          <div>
            <p class="text-[#627189] dark:text-textDark">Province</p>
            <p class="font-semibold text-[#000000] dark:text-white">
              {{ officerObj.province }}
            </p>
          </div>

          <div>
            <p class="text-[#627189] dark:text-textDark">District</p>
            <p class="font-semibold text-[#000000] dark:text-white">
              {{ officerObj.district }}
            </p>
          </div>
        </div>
      </div>

      <div class="border-[#F1F7FA] border-[3px] rounded-lg shadowmd p-6">
        <p class="font-semibold text-[#030308] dark:text-white ">Bank Details</p>

        <div class="grid grid-cols-2 gap-4 text-[#627189] my-4">
          <div>
            <p class="text-[#627189] dark:text-textDark">Account Holder’s Name</p>
            <p class="font-semibold text-[#000000] dark:text-white">
              {{ officerObj.accHolderName }}
            </p>
          </div>

          <div>
            <p class="text-[#627189] dark:text-textDark">Account Number</p>
            <p class="font-semibold text-[#000000] dark:text-white">
              {{ officerObj.accNumber }}
            </p>
          </div>

          <div>
            <p class="text-[#627189] dark:text-textDark">Bank Name</p>
            <p class="font-semibold text-[#000000] dark:text-white">
              {{ officerObj.bankName }}
            </p>
          </div>

          <div>
            <p class="text-[#627189] dark:text-textDark">Branch Name</p>
            <p class="font-semibold text-[#000000] dark:text-white">
              {{ officerObj.branchName }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>